export enum BroadcastEventType {
    unconsumedChatMessage = 'unconsumedChatMessage',
    employerFeedNotification = 'employerFeedNotification',
}
